import { render, staticRenderFns } from "./CreateNewRest.vue?vue&type=template&id=04dfe096&scoped=true&"
import script from "./CreateNewRest.vue?vue&type=script&lang=js&"
export * from "./CreateNewRest.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewRest.vue?vue&type=style&index=0&id=04dfe096&scoped=true&lang=css&"
import style1 from "./CreateNewRest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dfe096",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAutocomplete,VDatePicker,VIcon,VMenu,VSnackbar})
